const UserSelect = "Select";

export default UserSelect;